import { AppRouter } from './router';
import { AppShell } from './components/AppShell';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { HeroUIProvider } from './providers/HeroUIProvider';

function App() {
  return (
    <AppErrorBoundary>
      <HeroUIProvider>
        <AppShell>
          <AppRouter />
        </AppShell>
      </HeroUIProvider>
    </AppErrorBoundary>
  );
}

export default App;
